<template>
  <footer>
    <div class="copyright">
      <div>&#169; Fundacja Greenpeace Polska {{ currentYear }}</div>
    </div>
  </footer>
</template>

<script>

export default {
  name: "Footer",
  data() {
    return {
      title: "footer",
      currentYear: new Date().getFullYear(),
    };
  },

};
</script>


